import React from 'react'

function DocumentCard({item}) {
    return (
        <>
            <div className="d-flex flex-column align-items-center">
                <ion-icon
                    name="document-attach-outline"
                    style={{ fontSize: '62px', color: 'gray' }}
                ></ion-icon>
                <p className="text-center mt-2">{item?.Data?.Title || 'Document'}</p>
                <div className="mt-3 d-flex gap-2">
                    <a
                        href={item.document}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-secondary btn-lg p-2"
                    >
                        View
                    </a>
                    <a
                        href={item.document}
                        target="_blank"
                        rel="noopener noreferrer"
                        download
                        className="btn btn-primary btn-lg p-2"
                    >
                        Download
                    </a>
                </div>
            </div>
        </>
    )
}

export default DocumentCard